import React, { useContext } from 'react';
import { Plugin, TemplateConnector } from '@devexpress/dx-react-core';
import { LookupEditCell } from './LookupEditCell';
import TableContext from './table-context';

const EditCell = (props) => {
	const ctx = useContext(TableContext);
	const currentColumnName = props.column.name;

	return (
		<Plugin>
			<TemplateConnector>
				{/* {getters}, {actions} */}
				{({ createRowChange, addedRows, editingRowIds, rowChanges, isColumnEditingEnabled }, { changeRow, changeAddedRow }) => {
					const paramsForSetColTypeAndDisabled = {
						rowId: props.row.id,
						currentRow: !!rowChanges[props.row.id] ? { ...props.row, ...rowChanges[props.row.id] } : props.row,
						editingEnabledCell: isColumnEditingEnabled(currentColumnName),
						colType: props.column.type,
						currentColumnName: currentColumnName,
						availableColumnValues: props.column.availableColumnValues,
					};
					const { colType, disabled, availableColumnValues } = ctx.setColTypeAndEditingState(paramsForSetColTypeAndDisabled);
					const paramsForSetPlaceholder = {
						currentRow: !!rowChanges[props.row.id] ? rowChanges[props.row.id] : props.row,
						currentColumnName: currentColumnName,
						defaultPlaceholder: props.column.placeholder || '',
					};
					const placeholder = ctx.setPlaceholder(paramsForSetPlaceholder);

					const processValueChange = (newColumnValue, row) => {
						// change the current cell value which user changed
						props.onValueChange(newColumnValue);

						// 0 is for the new row added case
						const editRowId = editingRowIds.find((id) => id === row.id) || 0;
						const isCurrentRowNew = addedRows.length > 0 && props.row.id === addedRows[0].id;

						const paramsForHandleAffectedColChanges = {
							currentColumnName: currentColumnName,
							newColumnValue: newColumnValue,
							editRowId: editRowId,
							row: row,
							createRowChange: createRowChange,
						};
						const changesObjArray = ctx.handleAffectedColChanges(paramsForHandleAffectedColChanges);

						if (isCurrentRowNew) {
							changesObjArray.forEach((changeArgs) => changeAddedRow(changeArgs));
						} else {
							changesObjArray.forEach((changeArgs) => changeRow(changeArgs));
						}
					};

					return (
						<LookupEditCell
							{...props}
							onValueChange={processValueChange}
							editingEnabled={!disabled}
							placeholder={placeholder}
							availableColumnValues={availableColumnValues}
							colType={colType}
						/>
					);
				}}
			</TemplateConnector>
		</Plugin>
	);
};

export default EditCell;
